import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Loader2 } from "lucide-react";
import { mcPost } from "./api";

export const DuplicatesDialog = ({ open, onClose, token, onDone }) => {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  useEffect(() => {
    if (!open) return;
    setP(null); setResult(null);
    mcPost("duplicates/preview", { token }).then(setP).catch((e) => toast.error(e.message));
  }, [open, token]);
  const fix = async () => {
    if (!window.confirm(`Back up and archive ${p.records_to_archive} duplicate records? Nothing is deleted.`)) return;
    setBusy(true);
    try { const r = await mcPost("duplicates/fix", { token }); setResult(r); toast.success(`Archived ${r.archived} duplicates (backup batch ${r.batch_id?.slice(0, 8)})`); onDone(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="duplicates-dialog">
        <DialogHeader><DialogTitle>Duplicate menu records — preview</DialogTitle></DialogHeader>
        {!p ? <div className="py-8 flex justify-center"><Loader2 className="animate-spin" /></div> : (
          <div className="space-y-3 text-sm">
            <p data-testid="dup-summary">Groups (same name + category + serving): <b>{p.duplicate_groups}</b> · Records to archive: <b>{p.records_to_archive}</b> · Conflicts for review: <b>{p.conflicts}</b></p>
            {result && <p className="rounded bg-emerald-50 p-2 text-emerald-800" data-testid="dup-result">Done: {result.archived} archived, {result.backup_records} records backed up, {result.conflict_groups} groups flagged for review.</p>}
            <ul className="space-y-1 text-xs">
              {p.groups.map((g) => (
                <li key={g.keep_id} className="border-b pb-1" data-testid={`dup-group-${g.keep_id}`}>
                  <b>{g.name}</b> · {g.category} · {g.serves || "—"} — keep 1, archive {g.archive_ids.length}
                  {Object.keys(g.merge_center_prices).length > 0 && <span className="text-blue-700"> · merges centre prices: {Object.keys(g.merge_center_prices).join(", ")}</span>}
                  {g.conflicts.length > 0 && <span className="text-red-700"> · {g.conflicts.length} conflict(s): {g.conflicts.map((c) => `${c.field} kept ${JSON.stringify(c.kept)} vs ${JSON.stringify(c.other)}`).join("; ")}</span>}
                </li>
              ))}
            </ul>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="dup-close-btn">Close</Button>
          <Button onClick={fix} disabled={busy || !p || p.records_to_archive === 0} data-testid="dup-fix-btn">Back up & archive duplicates</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
